import normal from './typography.json'
export default {normal}
